<style type="text/css">
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 300px;
        margin: 0px auto;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        font-family: 'NotoKrD','NanumSquare',Dotum,sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

</style>

<template>
    <div id="popup">
        <template>
            <layout-content v-for="(info,index) in list"
                            v-bind:key="info.id + index"
                            :info="info"
                            :index="index"></layout-content>
        </template>
    </div>
</template>

<script>
    import layoutContent from './content.vue'

    export default {
        name: 'popupLayout',
        components:{
            'layout-content':layoutContent
        },
        data: function() {
            return{
            }
        },
        computed: {
            popupInfo:function(){
                return this.$store.getters.getPopupInfo;
            },
            showAt: function(){
                return this.popupInfo.showAt;
            },
            list: function(){
                return this.popupInfo.list;
            }
        },
        watch: {
            list: function(newVal){
                if(newVal.length > 0){
                    this.$store.commit('setPopupShowAt',true);
                    const modalList = this.list.filter(function(info){ return info.se.indexOf('modal') > -1 });
                    if(modalList.length > 0) document.getElementById('content-area').style.overflowY = 'hidden';
                    else document.getElementById('content-area').style.overflowY = 'auto';
                }else{
                    this.$store.commit('setPopupShowAt',false);
                    document.getElementById('content-area').style.overflowY = 'auto';
                }
            }
        },
        mounted: function() {
        }
    }
</script>

<style scoped>

</style>